// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Field_Field__1W6v{margin-top:15px}.Field_Field__1W6v:first-child{margin-top:0}.Field_FieldHeader__2Ygw{display:block;margin:0 0 5px}", "",{"version":3,"sources":["node_modules/@sinclair-digital/sbg-storyline-components/src/components/Field/Field.css"],"names":[],"mappings":"AAAA,mBACE,eAAA,CAGF,+BACE,YAAA,CAGF,yBACE,aAAA,CACA,cAAA","file":"Field.css","sourcesContent":[".Field {\n  margin-top: 15px;\n}\n\n.Field:first-child {\n  margin-top: 0;\n}\n\n.FieldHeader {\n  display: block;\n  margin: 0 0 5px;\n}\n"]}]);
// Exports
exports.locals = {
	"Field": "Field_Field__1W6v",
	"FieldHeader": "Field_FieldHeader__2Ygw"
};
module.exports = exports;
